
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`La petite histoire`}</em></p>
    <p>{`Le patron de Moderna, Stéphane Bancel, est français. Il s'est fait remarquer en
mars 2020, lorsque Donald Trump a convoqué les entreprises pharmaceutiques et
exigé un vaccin. Il a alors affirmé qu'un sérum serait commercialisable en
quelques mois.`}</p>
    <p>{`Moderna espère maintenant utiliser la technique de l'ARNm pour développer
d'autres traitements, notamment contre le cancer. Selon la RTS, une poignée
d'investisseurs genevois ont joué un rôle crucial pour financer les débuts de
l'entreprise.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;